import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import style from "./style.module.pcss";
var cn = classNames.bind(style);
var StoryPreview = function StoryPreview(_ref) {
  var image = _ref.image,
    text = _ref.text,
    _ref$viewed = _ref.viewed,
    viewed = _ref$viewed === void 0 ? false : _ref$viewed,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: cn('wrap'),
    onClick: onClick,
    type: "button",
    "data-t-id": "StoriesV2-StoryPreview"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('preview', {
      'preview--not-viewed': !viewed
    })
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F ".concat(text || '', " ").concat(viewed ? '' : 'не ', "\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0430"),
    className: lazy ? 'swiper-lazy' : undefined,
    loading: lazy ? 'lazy' : 'eager',
    src: image
  })), /*#__PURE__*/React.createElement(Text, {
    size: "size6-r"
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    className: cn('text'),
    "data-t-id": "StoriesV2-StoryPreview"
  }, text)));
};
export { StoryPreview };